/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-webkit-animation:1.5s linear infinite ui-loader-spin;animation:1.5s linear infinite ui-loader-spin;border-radius:50%;border:4px solid #4a8ee0;border-left-color:transparent;display:block;height:22px;width:22px}@-webkit-keyframes ui-loader-spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes ui-loader-spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}"];
export { styles as styles };
